export default __webpack_public_path__ + "static/media/medical-records.5c4ea79a.svg";